import { render } from "./DeliveryShowView.vue?vue&type=template&id=4f08535a&scoped=true"
import script from "./DeliveryShowView.vue?vue&type=script&lang=js"
export * from "./DeliveryShowView.vue?vue&type=script&lang=js"

import "./DeliveryShowView.vue?vue&type=style&index=0&id=4f08535a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f08535a"]])

export default __exports__